import React, { useContext, useEffect, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Status } from '../../constants/Colors';
import FontSizes from '../../constants/FontSizes';
import { AuthContext } from '../../context/AuthProvider';
import { OrganizationContext } from '../../context/OrganizationProvider';

const OrganizationLogo = () => {
    const { organizations } = useContext(AuthContext);
    const { organizationId } = useContext(OrganizationContext);
    const [currentOrgAbbreviated, setCurrentOrgAbbreviated] = useState();

    useEffect(() => {
        const currentOrganization =
            organizations.find(org => org.organizationId === organizationId);

        const currentOrganizationAbbreviated =
            currentOrganization.organizationName.split(' ').map(i => i.charAt(0).toUpperCase());

        setCurrentOrgAbbreviated(currentOrganizationAbbreviated);
    }, []);

    return (
        <View style={styles.circleContainer}>
            <Text style={styles.text}>{currentOrgAbbreviated}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    circleContainer: {
        width: 100,
        height: 100,
        borderRadius: 100 / 2,
        backgroundColor: Status.complete,
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        color: 'white',
        fontSize: FontSizes.large,
        fontWeight: '700',
        letterSpacing: 1.5,
        textAlign: 'center',
    }
});

export default OrganizationLogo;